import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import entitiesReducer from './entities';
import authReducer from './auth'

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  blacklist: ['idk']
}

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  entities: entitiesReducer
})

export default rootReducer